//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'
import dayjs from '~/modules/dayjs'
import round from '~/mixins/round'
import ceil from '~/mixins/ceil'
import GTM from '~/utils/classes/Gtm'
import vAbsoluteElement from '~/components/v-absolute-element.vue'
import BoatReviewSimple from '~/components/Boats/card/boat-review-simple'

export default {
  name: 'BoatCardBlog',
  components: {
    BoatReviewSimple,
    vAbsoluteElement
  },
  filters: {
    feetToMeters (value) {
      return (parseFloat(value) * 0.3048).toFixed(2)
    },
    removeBetweenBrackets (value) {
      return value.replace(/\([\s\S]*?\)/g, '')
    }
  },
  mixins: [round, ceil],
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    boatTypes: {
      type: Array,
      default: []
    },
    searchTerms: {
      type: Object,
      default: () => {}
    },
    favoriteIconType: {
      type: String,
      default: 'default'
    },
    isShowStatus: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      loadingBoat: false,
      stars: new Array(5),
      gtm: new GTM(this.$gtm),
      hoverPremiumTip: true
    }
  },
  computed: {
    ...mapGetters({
      check: 'auth/check'
    }),
    getPreBook () {
      return this.item?.underOption
    },
    getTerms () {
      const result = []
      if (this.item?.terms?.length) {
        return this.item.terms
      }
      return result
    },
    getDuration () {
      const raw = this.item.rentingOption
      const int = parseInt(this.item.rentingOption)
      if (!raw) {
        return this.searchTerms?.duration
      }
      let multiple = 1
      if (raw.includes('week')) {
        multiple = 7
      }
      if (raw.includes('month')) {
        multiple = 30
      }
      if (raw.includes('months')) {
        multiple = 30
      }
      return int * multiple + 1
    },
    imageAltText () {
      return `${this.item.boat_type}, ${this.item.name} (${this.item.year}) in ${this.item.city}, ${this.item.country}`
    },
    getDetailPageUrl () {
      const urlParams = {}
      if (
        !this.isDefaultDate(this.searchTerms.start_date) ||
        this.searchTerms.start_date !== null
      ) {
        urlParams.start_date = this.searchTerms.start_date
      }

      if (this.searchTerms.duration !== 7) {
        urlParams.duration = this.searchTerms.duration
      }

      if (this.searchTerms.guests && this.searchTerms.guests !== 4) {
        urlParams.guests = this.searchTerms.guests
      }

      if (this.$route?.query) {
        for (const [key, value] of Object.entries(this.$route?.query)) {
          urlParams[key] = value
        }
      }
      return urlParams
    },
    getPriceFrom () {
      return this?.item?.discounts?.price_from || 0
    },
    isPremium () {
      return !!parseInt(this.item?.premium_boat, 10)
    }
  },
  methods: {
    setHoverPremium (value, id) {
      if (!this.$refs[`premium-tip-${id}`]) {
        return
      }
      if (value) {
        this.hoverPremiumTip = true
        this.$refs[`premium-tip-${id}`].show()
      } else {
        this.$nextTick(() => {
          this.hoverPremiumTip = false
        })
        this.$nextTick(() => {
          this.$nextTick(() => {
            this.$nextTick(() => {
              this.hoverPremiumTip = true
            })
          })
        })
      }
    },
    loading () {
      this.loadingBoat = true
    },
    recordClick (loading = false) {
      if (loading) {
        this.loading()
      }

      if (
        process.client &&
        this.index &&
        window.hasOwnProperty('dataLayer')
      ) {
        this.gtm.selectItem({ ...this.item })
      }
    },

    isDefaultDate (date) {
      return dayjs().day(6).format('YYYY-MM-DD') === date
    }
  }
}
